import { ORDER_OPTIONS } from '~/constants';

export default defineNuxtRouteMiddleware(to => {
  const sort = ORDER_OPTIONS.find(option => option.value === to.query.sort);
  const page = to.query.page;
  const size = to.query.size;
  const invertersBrand = to.query.inverters_brand;
  const invertersElectricConnection = to.query.inverters_electric_connection;
  const modulesBrand = to.query.modules_brand;
  const power = to.query.power;
  const stringBox = to.query.string_box;
  const structureInstallation = to.query.structure_installation;

  if (!sort || !page) {
    return navigateTo(
      {
        name: to.name as never,
        query: {
          ...to.query,
          sort: sort?.value || ORDER_OPTIONS[0].value,
          page: page || 1,
          size: size || 12,
          inverters_brand: invertersBrand || undefined,
          inverters_electric_connection:
            invertersElectricConnection || undefined,
          modules_brand: modulesBrand || undefined,
          power: power || undefined,
          string_box: stringBox || undefined,
          structure_installation: structureInstallation || undefined,
        },
      },
      {
        redirectCode: 302,
      },
    );
  }
});
